module.exports = __webpack_public_path__ + "img/partner_9.da7f31fe.png";